import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { useLeaveStore } from '@/stores/leave'
import { computed } from 'vue'
import TextContent from '@/components/TextContent.vue'
import { translate } from '@/helpers/translate'


export default /*#__PURE__*/_defineComponent({
  __name: 'DaysChart',
  setup(__props) {

const leaveStore = useLeaveStore()

const daysOffMom = computed(() => leaveStore.totalDaysUsed(true))
const daysOffPartner = computed(() => leaveStore.totalDaysUsed(false))
const maxWidth = 300

const momFactor = computed(() => {
    return daysOffMom.value / (daysOffMom.value + daysOffPartner.value)
})

const widthMom = computed(() => Math.round(momFactor.value * maxWidth))

const partnerFactor = computed(() => {
    return daysOffPartner.value / (daysOffMom.value + daysOffPartner.value)
})

const widthPartner = computed(() =>  Math.round(partnerFactor.value * maxWidth))
const standardColor = '#cccccc'
const goodColor = '#6fde5b'
const color1 = 'f72020'
const color2 = 'ffb5bf'

const momColor = computed(() => {
    if (daysOffMom.value === daysOffPartner.value) {
        return goodColor
    }

    if (daysOffMom.value < daysOffPartner.value) {
        return standardColor
    }

    const more = daysOffMom.value - daysOffPartner.value
    const max = 40
    const ratio = Math.min(1, more / max)
    return getColor(color1, color2, ratio)
})

const partnerColor = computed(() => {
    if (daysOffMom.value === daysOffPartner.value) {
        return goodColor
    }

    if (daysOffPartner.value < daysOffMom.value) {
        return standardColor
    }

    const more = daysOffPartner.value - daysOffMom.value
    const max = 40
    const ratio = Math.min(1, more / max)
    return getColor(color1, color2, ratio)
})

function getColor(color1: string, color2: string, ratio: number) {
    var hex = function(x: any) {
        x = x.toString(16);
        return (x.length == 1) ? '0' + x : x;
    };

    var r = Math.ceil(parseInt(color1.substring(0,2), 16) * ratio + parseInt(color2.substring(0,2), 16) * (1-ratio));
    var g = Math.ceil(parseInt(color1.substring(2,4), 16) * ratio + parseInt(color2.substring(2,4), 16) * (1-ratio));
    var b = Math.ceil(parseInt(color1.substring(4,6), 16) * ratio + parseInt(color2.substring(4,6), 16) * (1-ratio));

    return '#' + hex(r) + hex(g) + hex(b);
}

const { t } = translate()

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.container)
  }, [
    _createVNode(TextContent, null, {
      default: _withCtx(() => [
        _createElementVNode("h2", null, _toDisplayString(_unref(t)('chartTitle')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("ul", null, [
      _createElementVNode("li", {
        class: _normalizeClass(_ctx.$style.item)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.bar),
          style: _normalizeStyle({ width: _unref(widthMom) + 'px', background: _unref(momColor) })
        }, null, 6),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.value)
        }, _toDisplayString(_unref(t)('chartDaysMom', { days: Math.round(_unref(daysOffMom) * 10) / 10 })) + " (" + _toDisplayString(Math.round(_unref(momFactor) * 100)) + "%)", 3)
      ], 2),
      _createElementVNode("li", {
        class: _normalizeClass(_ctx.$style.item)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.bar),
          style: _normalizeStyle({ width: _unref(widthPartner) + 'px', background: _unref(partnerColor) })
        }, null, 6),
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.$style.value)
        }, _toDisplayString(_unref(t)('chartDaysPartner', { days: Math.round(_unref(daysOffPartner) * 10) / 10 })) + " (" + _toDisplayString(Math.round(_unref(partnerFactor) * 100)) + "%)", 3)
      ], 2)
    ])
  ], 2))
}
}

})